import React from 'react';

import { CleanNote } from '../../../../export-types/cleaned-types';
import { ConfirmModal } from '../../../common/confirm-modal';
import { ModalsService } from '../../../../services/modals.service';
import classNames from 'classnames';
import moment from 'moment';
import useSWRMutation from 'swr/mutation';
import { trpc, RouterInput } from '../../../../api/trpc';
import { Gallery } from '../../../common/gallery/gallery';
import { getFileV2ApiUrl } from '../../../../utils/common.utils';
import PdfIcon from '../../../../assets/pdf-file.svg';

type Props = {
  self: boolean;
  innerRef?: (element: any) => void;
  message: CleanNote;
  onDelete?: () => void;
  orderId: string;
};

export const CustomsDeliveryNoteMessageCard = (props: Props) => {
  const { trigger } = useSWRMutation(
    ['customsDeliveryNotes.deleteNote'],
    (_k, { arg }: { arg: RouterInput['customsDeliveryNotes']['deleteNote'] }) =>
      trpc.customsDeliveryNotes.deleteNote.mutate(arg),
  );
  const formatMessage = (message: string) => {
    const lines = message.trim().split('\n');
    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index !== lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const deleteMessage = async () => {
    await ModalsService.createModal(ConfirmModal, {
      title: 'Удалить сообщение',
      buttonText: 'Удалить',
    });
    await trigger({
      noteId: props.message.id,
      customsDeliveryOrderId: props.orderId,
    });
    props.onDelete && props.onDelete();
  };

  return (
    <div
      ref={props.innerRef}
      className={classNames(
        'rounded mx-3 my-1 align-self-start',
        props.self ? 'bg-green-200 align-self-end' : 'bg-gray align-self-start',
      )}
      style={{ wordBreak: 'break-all' }}
    >
      <div className="d-flex flex-column gap-0.5 m-2">
        <div className="d-flex flex-row gap-2 ">
          <div className="fw-500">{props.message.user.name}</div>
          <div className="color-gray-400">
            {moment(props.message.createdAt).format('HH:mm')}
          </div>
          {props.self && (
            <div onClick={() => deleteMessage()}>
              <i className="bi bi-trash color-gray-400" />
            </div>
          )}
        </div>
        <div>{formatMessage(props.message.noteText)}</div>
        {(props.message.attachments || []).length > 0 ? (
          <div>
            <Gallery className="mt-2">
              {props.message.attachments?.map((file, index) => (
                <a
                  href={getFileV2ApiUrl(file.id)}
                  key={index}
                  data-iframe={file.type === 'pdf'}
                >
                  <img
                    className="rounded fit-cover me-2"
                    src={
                      file.type === 'pdf'
                        ? PdfIcon
                        : getFileV2ApiUrl(file.id, '64x64')
                    }
                    width={64}
                    height={64}
                    alt=""
                  />
                </a>
              ))}
            </Gallery>
          </div>
        ) : null}
      </div>
    </div>
  );
};
